import { useState } from "react";
import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";

const validateEmail = (email) => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const Email = ({ text, node, handleAnswerChange, isNodeOpen, qfusermode }) => {
  const [error, setError] = useState(false);

  const changeError = (value) => {
    setError(value);
  };
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      error={error}
      rightComponent={
        <EmailInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          changeError={changeError}
          qfusermode={qfusermode}
        ></EmailInput>
      }
    ></SimpleQuestion>
  );
};

const EmailInput = ({ node, handleAnswerChange, changeError, qfusermode }) => {
  // const currentnode = useSelector(getCurrentNode);
  // const isOnThisNode = node.id === currentnode.id;

  const [input, setInput] = useState(node.answer ? node.answer : "");

  const handleBlur = (event) => {
    if (input) {
      if (!validateEmail(input)) {
        changeError("Please Enter Valid Email!");
      } else {
        changeError("");
        if (node.answer != input)
          handleAnswerChange(input ? input.trim() : input);
      }
    } else {
      handleAnswerChange("");
    }
  };

  const handleChange = (event) => {
    changeError("");
    setInput(event.target.value);
  };

  const handleEmailChange = (event) => {
    changeError("");
    let email = event.target.value;
    handleAnswerChange(email ? email.trim() : email);
  };
  return (
    <input
      type="text"
      id={"EmailInput" + node.id}
      style={{ ...theme.inputStyle }}
      value={input}
      readOnly={qfusermode === INSURER ? true : false}
      onChange={handleChange}
      onBlur={handleBlur}
    ></input>
  );
};

export default Email;
